import request from '../utils/request';

/**
 * 获取店铺列表
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.page_size - 每页数量
 * @returns {Promise}
 */
export const getStores = (params) => {
  return request.get('/stores', { params });
};

/**
 * 获取店铺详情
 * @param {number} id - 店铺ID
 * @returns {Promise}
 */
export const getStoreById = (id) => {
  return request.get(`/stores/${id}`);
};

/**
 * 创建店铺
 * @param {Object} data - 店铺信息
 * @param {string} data.name - 店铺名称
 * @param {string} data.address - 店铺地址
 * @param {string} data.phone - 联系电话
 * @returns {Promise}
 */
export const createStore = (data) => {
  const newData = { ...data };
  console.log(newData)
  return request.post('/stores', newData);
};

/**
 * 更新店铺
 * @param {number} id - 店铺ID
 * @param {Object} data - 店铺信息
 * @param {string} data.name - 店铺名称
 * @param {string} data.address - 店铺地址
 * @param {string} data.phone - 联系电话
 * @returns {Promise}
 */
export const updateStore = (id, data) => {
  return request.put(`/stores/${id}`, data);
};

/**
 * 删除店铺
 * @param {number} id - 店铺ID
 * @returns {Promise}
 */
export const deleteStore = (id) => {
  return request.delete(`/stores/${id}`);
};

export const visibleStore = async (user_id) => {
  return await request({
    url: `/stores/visible?user_id=${user_id}`,
    method: 'get',
  })
};



/**
 * 获取店铺可见用户
 * @param {number} id - 店铺ID
 * @returns {Promise}
 */
export const visibleUser = async (id) => {
  return await request({
    url: `/stores/${id}/users`,
    method: 'get',
  })
}

export const batchSetStorePermissions = async (data) => {
  return await request({
    url: '/stores/permission',
    method: 'post',
    data: data,
  })
}

export const statisticsStore = async (ip, softwareType) => {
  let targetUrl = `${ip}/store/statistics`
  
  // 添加软件类型参数
  if (softwareType) {
    targetUrl += `?software_type=${softwareType}`
  }
  
  return await request.get('/proxy', {
    params: {
      address: encodeURIComponent(targetUrl)
    }
  });
};


// 添加店铺健康检查API
export const checkStoreHealth = async (ip) => {
  const targetUrl = `${ip}/health`;
  return await request.get('/proxy', {
    params: {
      address: encodeURIComponent(targetUrl)
    }
  });
};

export const getEmployeeList = async (ip) => {
  const targetUrl = `${ip}/empleado/list`
  return await request.get('/proxy', {
    params: {
      address: encodeURIComponent(targetUrl)
    }
  })
}

export const getOrderInfo = async (ip, startDate, endDate, operador_id, softwareType) => {
  console.log('getOrderInfo - 参数: ', startDate, endDate, operador_id, softwareType)
  let targetUrl = ""
  if (operador_id) {
    targetUrl = `${ip}/order/statistics?start_date=${startDate}&end_date=${endDate}&operador_id=${operador_id}`
  } else {
    targetUrl = `${ip}/order/statistics?start_date=${startDate}&end_date=${endDate}`
  }
  
  // 添加软件类型参数
  if (softwareType) {
    targetUrl += `&software_type=${softwareType}`
  }
  
  return await request.get('/proxy', {
    params: {
      address: encodeURIComponent(targetUrl)
    }
  })
};

export const getExpensesDetails = async (ip, startDate, endDate, operador_id, softwareType) => {
  console.log('getExpensesDetails - 参数: ', startDate, endDate, operador_id, softwareType)
  let targetUrl = ""
  if (operador_id) {
    targetUrl = `${ip}/expenses/statistics?start_date=${startDate}&end_date=${endDate}&operador_id=${operador_id}`
  } else {
    targetUrl = `${ip}/expenses/statistics?start_date=${startDate}&end_date=${endDate}`
  }
  
  // 添加软件类型参数
  if (softwareType) {
    targetUrl += `&software_type=${softwareType}`
  }
  
  return await request.get('/proxy', {
    params: {
      address: encodeURIComponent(targetUrl)
    }
  })
};


// 获取退货明细
export const getRefund = async (ip, startDate, endDate, operador_id, softwareType) => {
  console.log('geRefund - 参数: ', startDate, endDate, operador_id, softwareType)
  let targetUrl = ""
  if (operador_id) {
    targetUrl = `${ip}/refund?start_date=${startDate}&end_date=${endDate}&operador_id=${operador_id}`
  } else {
    targetUrl = `${ip}/refund?start_date=${startDate}&end_date=${endDate}`
  }
  
  // 添加软件类型参数
  if (softwareType) {
    targetUrl += `&software_type=${softwareType}`
  }
  
  return await request.get('/proxy', {
    params: {
      address: encodeURIComponent(targetUrl)
    }
  })
};

export const getRefundDetail = async (ip, startDate, endDate, formaDePago, operador_id, softwareType) => { 
  
  console.log('geRefundDetail - 参数: ', startDate, endDate, formaDePago, operador_id, softwareType)
  let targetUrl = ""
  if (operador_id) {
    targetUrl = `${ip}/refund/detail?start_date=${startDate}&end_date=${endDate}&forma_de_pago=${formaDePago}&operador_id=${operador_id}`
  } else {
    targetUrl = `${ip}/refund/detail?start_date=${startDate}&end_date=${endDate}&forma_de_pago=${formaDePago}`
  }
  
  // 添加软件类型参数
  if (softwareType) {
    targetUrl += `&software_type=${softwareType}`
  }
  
  return await request.get('/proxy', {
    params: {
      address: encodeURIComponent(targetUrl)
    }
  })
};

export const getTimezone = async (ip) => {
  const targetUrl = `${ip}/timezone`
  return await request.get('/proxy', {
    params: {
      address: encodeURIComponent(targetUrl)
    }
  })
};

// 获取电子票统计数据（直接调用API，不走proxy）
export const getElectronicTicketStats = async (storeId) => {
  try {
    // 直接调用电子票API，不通过proxy
    return await request.get(`/electronic/statistics`, {
      params: {
        storeId: storeId
      }
    });
  } catch (error) {
    console.error('获取电子票统计数据失败:', error);
    throw error;
  }
};

export const getElectronicTicketList = async (storeId, startDate, endDate) => {
  try {
    const params = { storeId };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    return await request.get(`/electronic/tickets`, {
      params
    });
  } catch (error) {
    console.error('获取电子票列表失败:', error);
    throw error;
  }
};

/**
 * 获取所有可用的软件类型列表
 * @returns {Promise}
 */
export const getSoftwareTypes = async () => {
  // 直接调用management的API，不需要通过proxy
  return await request.get('/software_types');
};
